import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { notificationsApi } from '../../api/notifications'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import Card from '../../components/common/Card'
import './Notifications.css'

const Notifications = () => {
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => notificationsApi.getNotifications(),
  })

  const markAsReadMutation = useMutation({
    mutationFn: (id) => notificationsApi.markAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['notifications'])
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (id) => notificationsApi.deleteNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['notifications'])
    },
  })

  if (isLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  const notifications = data?.data?.notifications || []

  return (
    <div className="notifications-page bg-gray-900 min-h-screen">
      <Header />
      <main className="notifications-main bg-gray-900">
        <div className="container mx-auto px-4 py-8">
          <h1 className="page-title text-white">الإشعارات</h1>
          <div className="notifications-list">
            {notifications.map((notification) => (
              <Card
                key={notification.id}
                className={`notification-card ${!notification.read ? 'unread' : ''}`}
              >
                <div className="notification-header">
                  <h3 className="notification-title">{notification.title}</h3>
                  {!notification.read && <span className="unread-badge">جديد</span>}
                </div>
                <p className="notification-message">{notification.message}</p>
                <div className="notification-footer">
                  <span className="notification-date">
                    {new Date(notification.created_at).toLocaleDateString('ar-EG')}
                  </span>
                  <div className="notification-actions">
                    {!notification.read && (
                      <button
                        className="action-button"
                        onClick={() => markAsReadMutation.mutate(notification.id)}
                      >
                        تم القراءة
                      </button>
                    )}
                 
                  </div>
                </div>
              </Card>
            ))}
            {notifications.length === 0 && (
              <div className="empty-state">
                <p>لا توجد إشعارات</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Notifications

